import React, {useRef, useState} from 'react'

import {useDashboard} from '../../contexts/DashboardContext'
import useOutsideAlerter from '../../hooks/useOutsideAlerter'
import Icon from '../icons/Icon'
import {ProfileMenuItem} from './types'

const ProfileMenuItems = ({items}: {items: ProfileMenuItem[];}) => {
  return (
    <div>
      {
        items.map((item, idx) =>{
          const {text, icon, onClick} = item
          const key = `profile-menu-item-${idx}`
          return (
            <button
              key={key}
              className="flex items-center text-left justify-start w-full px-2 rounded-lg min-h-[40px] gap-2 cursor-pointer hover:bg-kwota-neutral-200"
              onClick={onClick}
            >
              <Icon
                icon={icon}
                className="flex items-center justify-center fill-kwota-neutral-800"
              />
              <p className="text-base text-kwota-neutral-800">{text}</p>
            </button>
          )
        })
      }
    </div>
  )
}

const ProfileMenu = () => {
  const {organizationName: organization, handleProfileMenuItemClick, profileMenuItems = [], isAuthenticated} = useDashboard()
  const [isOpen, setIsOpen] = useState(false)
  const menuRef = useRef(null)
  useOutsideAlerter(menuRef, isOpen, () => setIsOpen(false))

  const toggleOpen = () => setIsOpen(prevOpen => !prevOpen)

  const authMenuItem: ProfileMenuItem = {
    icon: isAuthenticated ? 'logout' : 'login',
    text: isAuthenticated ? 'Log out' : 'Login / Sign up',
    onClick: handleProfileMenuItemClick
  }

  const profileMenuItemsWithAuthMenu = [...profileMenuItems, authMenuItem]

  return (
    <div ref={menuRef} className="relative">
      <button
        type="button"
        className="flex items-center justify-center w-8 h-8 text-2xl font-semibold text-white uppercase rounded-full sm:w-10 sm:h-10 bg-kwota-navy-400 font-titillium focus:outline-none focus:ring focus:ring-kwota-primary-200 focus:ring-offset-0"
        id="user-menu-toggle"
        aria-expanded={isOpen}
        aria-controls="user-menu"
        aria-haspopup="menu"
        onClick={toggleOpen}
      >
        {isAuthenticated ? organization.substring(0, 1) : <Icon icon="user" className="fill-kwota-neutral-100" />}
      </button>

      {isOpen &&
        <div
          className="absolute right-0 z-50 mt-3 min-w-[208px] origin-top-right rounded-xl bg-kwota-neutral-100 px-3 py-4 space-y-4 shadow-lg focus:outline-none"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="user-menu"
        >
          {isAuthenticated &&
            <div
              className="block px-2 text-xl font-semibold text-kwota-neutral-800 font-titillium"
              id="user-menu-header"
            >
              {organization}
            </div>
          }
          <ProfileMenuItems items={profileMenuItemsWithAuthMenu} />
        </div>
      }
    </div>
  )
}

export default ProfileMenu
